import { Box, alpha, lighten, useTheme, useMediaQuery, Drawer, IconButton } from '@mui/material';
import { Outlet } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useContext } from 'react';
import { SidebarContext } from 'src/contexts/SidebarContext';

import Sidebar from './Sidebar';
import Header from './Header/index';

const SidebarLayout = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

    return (
        <Box display="flex" height="100vh" width="100%">
            {/* Drawer en móviles */}
            {isMobile && (
                <Drawer
                    anchor="left"
                    open={sidebarToggle}
                    onClose={toggleSidebar}
                    variant="temporary"
                    elevation={9}
                >
                    <Sidebar />
                </Drawer>
            )}

            {/* Botón para abrir menú en móviles */}
            {isMobile && (
                <Box sx={{ px: 2, pt: 1 }}>
                    <IconButton onClick={toggleSidebar}>
                        <MenuIcon />
                    </IconButton>
                </Box>
            )}

            {/* Sidebar fijo */}
            <Box
                sx={{
                    display: { xs: 'none', lg: 'block' },
                    width: theme.sidebar.width,
                    minWidth: theme.sidebar.width,
                    position: 'fixed',
                    height: '100vh',
                    zIndex: 1200,
                    backgroundColor:
                        theme.palette.mode === 'dark'
                            ? theme.palette.background.default
                            : '#FFFFFF'
                }}
            >
                <Sidebar />
            </Box>

            {/* Contenido + Header */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    marginLeft: { lg: theme.sidebar.width },
                    width: '100%'
                }}
            >
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        px: 2,
                        py: 2,
                        marginTop: 8,
                        backgroundColor:
                            theme.palette.mode === 'dark'
                                ? theme.palette.background.default
                                : '#f8f9fa',
                        '.MuiPageTitle-wrapper': {
                            background:
                                theme.palette.mode === 'dark'
                                    ? theme.colors.alpha.trueWhite[5]
                                    : theme.colors.alpha.white[50],
                            marginBottom: `${theme.spacing(4)}`,
                            boxShadow:
                                theme.palette.mode === 'dark'
                                    ? `0 1px 0 ${alpha(
                                        lighten(theme.colors.primary.main, 0.7),
                                        0.15
                                    )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                                    : `0px 2px 4px -3px ${alpha(
                                        theme.colors.alpha.black[100],
                                        0.1
                                    )}, 0px 5px 12px -4px ${alpha(
                                        theme.colors.alpha.black[100],
                                        0.05
                                    )}`
                        }
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

export default SidebarLayout;
